// Guest Checkout Popup
window.showGuestCheckoutPopup = function() {
  if (!document.getElementById('guest-checkout-popup')) {
    const popupHTML = `
      <div id="guest-checkout-popup" class="guest-checkout-popup-overlay">
        <div class="guest-checkout-popup">
          <div class="guest-checkout-popup__content">
            <p>Would you like to create an account or continue as a guest?</p>
            <div class="guest-checkout-popup__buttons">
              <button class="guest-checkout-popup__btn guest-checkout-popup__btn--signup btn alt-focus" data-action="signup">
                Sign Up
              </button>
              <button class="guest-checkout-popup__btn guest-checkout-popup__btn--guest btn alt-focus" data-action="guest">
                Continue as Guest
              </button>
            </div>
          </div>
        </div>
      </div>
    `;
    
    document.body.insertAdjacentHTML('beforeend', popupHTML);
  }
  
  const popup = document.getElementById('guest-checkout-popup');
  const signupBtn = popup.querySelector('[data-action="signup"]');
  const guestBtn = popup.querySelector('[data-action="guest"]');
  
  popup.classList.add('show');
  document.body.classList.add('guest-checkout-popup-open');
  
  const closePopup = () => {
    popup.classList.remove('show');
    document.body.classList.remove('guest-checkout-popup-open');
    
    setTimeout(() => {
      popup.removeEventListener('click', handleOverlayClick);
      signupBtn.removeEventListener('click', handleSignup);
      guestBtn.removeEventListener('click', handleGuest);
      document.removeEventListener('keydown', handleEscape);
    }, 300);
  };
  
  const handleOverlayClick = (e) => {
    if (e.target === popup) {
      closePopup();
    }
  };
  
  const handleSignup = () => {
    closePopup();
    setTimeout(() => {
      window.location.href = '/pages/become-a-customer';
    }, 100);
  };
  
  const handleGuest = () => {
    closePopup();
    setTimeout(() => {
      window.location.href = '/checkout';
    }, 100);
  };
  
  const handleEscape = (e) => {
    if (e.key === 'Escape') {
      closePopup();
    }
  };
  
  popup.addEventListener('click', handleOverlayClick);
  signupBtn.addEventListener('click', handleSignup);
  guestBtn.addEventListener('click', handleGuest);
  document.addEventListener('keydown', handleEscape);
  
  setTimeout(() => {
    signupBtn.focus();
  }, 100);
};

window.closeGuestCheckoutPopup = function() {
  const popup = document.getElementById('guest-checkout-popup');
  if (popup && popup.classList.contains('show')) {
    popup.classList.remove('show');
    document.body.classList.remove('guest-checkout-popup-open');
  }
};


document.addEventListener('click', function(e) {
  if (!e.target) return;

	if (e.target.hasAttribute('id') && e.target.getAttribute('id') === 'cart_submit') {
		e.preventDefault();
		e.stopPropagation();
		window.showGuestCheckoutPopup();
	}
});